import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { recordCheckIn, listCheckins } from '../Api/checkinsApi';

export function useCheckinList(search) {
  return useQuery({ queryKey: ['sfa', 'list', 'checkins', search ?? ''], queryFn: () => listCheckins(search) });
}

export function useRecordCheckIn(cmGuid) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: recordCheckIn,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['sfa', 'list', 'checkins'] });
      if (cmGuid) qc.invalidateQueries({ queryKey: ['sfa', 'detail', 'retailer-visits', cmGuid] });
      toast.success('Check-in recorded.');
    },
    onError: (err) => toast.error(err?.friendlyMessage || 'Could not record check-in.'),
  });
}
